

import ChatFeedback from '@/views/pages/qa/feedback/ChatFeedback.vue';
import TicketFeedback from '@/views/pages/qa/feedback/TicketFeedback.vue';
import { Component, Vue } from 'vue-property-decorator';
import { EscalationRepositoryInterface } from '@/services/QA/escalation/interfaces';
import FeedbackRepositoryInterface from '@/services/QA/feedback/interfaces';

@Component({
  components: {
    TicketFeedback,
    ChatFeedback,
  },
  inject: [
    'feedbackRepository',
  ],
})
export default class ViewFeedback extends Vue {
  private loading: boolean = true;
  private type!: string;
  private feedbackRepository: FeedbackRepositoryInterface;

  public async created(): Promise<void> {
    try {
      const feedbackId = Number(this.$route.params.feedbackId);
      const feedback = await this.feedbackRepository.getOneById(feedbackId);
      this.type = feedback.chat ? 'chat' : 'ticket';
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || JSON.stringify(e));
    }
  }
}
